/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "Refinery",
  "tagline": "An efficient graph solver for generating well-formed models",
  "url": "https://refinery.tools",
  "baseUrl": "/",
  "baseUrlIssueBanner": false,
  "trailingSlash": true,
  "staticDirectories": [
    "static",
    "build/javadocs"
  ],
  "plugins": [
    [
      "@docusaurus/plugin-content-docs",
      {
        "path": "src/docs",
        "routeBasePath": "/",
        "sidebarPath": "./sidebars.ts",
        "editUrl": "https://github.com/graphs4value/refinery/edit/main/subprojects/docs",
        "versions": {
          "current": {
            "path": "snapshot",
            "label": "0.3.1-SNAPSHOT 🚧"
          }
        },
        "beforeDefaultRemarkPlugins": [
          null
        ],
        "remarkPlugins": [
          [
            null,
            {
              "properties": {
                "objs": {
                  "file.encoding": "UTF-8",
                  "frontend.nodeVersion": "24.18.0",
                  "group": "tools.refinery",
                  "org.gradle.configuration-cache": "true",
                  "org.gradle.configuration-cache.parallel": "true",
                  "org.gradle.parallel": "true",
                  "systemProp.sonar.gradle.skipCompile": "true",
                  "systemProp.sonar.projectKey": "graphs4value_refinery",
                  "systemProp.sonar.organization": "graphs4value",
                  "systemProp.sonar.host.url": "https://sonarcloud.io",
                  "tools.refinery.release": "0.3.0",
                  "version": "0.3.1-SNAPSHOT"
                }
              }
            }
          ],
          [
            null,
            {
              "dashes": "oldschool"
            }
          ],
          null,
          null
        ]
      }
    ],
    [
      "@docusaurus/plugin-content-pages",
      {
        "beforeDefaultRemarkPlugins": [
          null
        ],
        "remarkPlugins": [
          [
            null,
            {
              "properties": {
                "objs": {
                  "file.encoding": "UTF-8",
                  "frontend.nodeVersion": "24.18.0",
                  "group": "tools.refinery",
                  "org.gradle.configuration-cache": "true",
                  "org.gradle.configuration-cache.parallel": "true",
                  "org.gradle.parallel": "true",
                  "systemProp.sonar.gradle.skipCompile": "true",
                  "systemProp.sonar.projectKey": "graphs4value_refinery",
                  "systemProp.sonar.organization": "graphs4value",
                  "systemProp.sonar.host.url": "https://sonarcloud.io",
                  "tools.refinery.release": "0.3.0",
                  "version": "0.3.1-SNAPSHOT"
                }
              }
            }
          ],
          [
            null,
            {
              "dashes": "oldschool"
            }
          ],
          null,
          null
        ]
      }
    ],
    [
      "@docusaurus/plugin-client-redirects",
      {
        "redirects": [
          {
            "to": "/develop/java/",
            "from": "/develop/"
          }
        ]
      }
    ],
    "@docusaurus/plugin-sitemap",
    "./src/plugins/loadersPlugin.ts"
  ],
  "themes": [
    [
      "@docusaurus/theme-classic",
      {
        "customCss": [
          "/home/runner/work/refinery/refinery/subprojects/docs/src/css/custom.css"
        ]
      }
    ],
    "@docusaurus/theme-search-algolia"
  ],
  "themeConfig": {
    "colorMode": {
      "respectPrefersColorScheme": true,
      "defaultMode": "light",
      "disableSwitch": false
    },
    "prism": {
      "additionalLanguages": [
        "bash",
        "groovy",
        "ini",
        "java",
        "kotlin"
      ],
      "theme": {
        "plain": {
          "backgroundColor": "hsl(230, 1%, 98%)",
          "color": "hsl(230, 8%, 24%)"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "cdata"
            ],
            "style": {
              "color": "hsl(230, 4%, 64%)"
            }
          },
          {
            "types": [
              "doctype",
              "punctuation",
              "entity"
            ],
            "style": {
              "color": "hsl(230, 8%, 24%)"
            }
          },
          {
            "types": [
              "attr-name",
              "class-name",
              "boolean",
              "constant",
              "number",
              "atrule"
            ],
            "style": {
              "color": "hsl(35, 99%, 36%)"
            }
          },
          {
            "types": [
              "keyword"
            ],
            "style": {
              "color": "hsl(301, 63%, 40%)"
            }
          },
          {
            "types": [
              "property",
              "tag",
              "symbol",
              "deleted",
              "important"
            ],
            "style": {
              "color": "hsl(5, 74%, 59%)"
            }
          },
          {
            "types": [
              "selector",
              "string",
              "char",
              "builtin",
              "inserted",
              "regex",
              "attr-value",
              "punctuation"
            ],
            "style": {
              "color": "hsl(119, 34%, 47%)"
            }
          },
          {
            "types": [
              "variable",
              "operator",
              "function"
            ],
            "style": {
              "color": "hsl(221, 87%, 60%)"
            }
          },
          {
            "types": [
              "url"
            ],
            "style": {
              "color": "hsl(198, 99%, 37%)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "textDecorationLine": "line-through"
            }
          },
          {
            "types": [
              "inserted"
            ],
            "style": {
              "textDecorationLine": "underline"
            }
          },
          {
            "types": [
              "italic"
            ],
            "style": {
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "important",
              "bold"
            ],
            "style": {
              "fontWeight": "bold"
            }
          },
          {
            "types": [
              "important"
            ],
            "style": {
              "color": "hsl(230, 8%, 24%)"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "backgroundColor": "hsl(220, 13%, 18%)",
          "color": "hsl(220, 14%, 71%)",
          "textShadow": "0 1px rgba(0, 0, 0, 0.3)"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "cdata"
            ],
            "style": {
              "color": "hsl(220, 10%, 40%)"
            }
          },
          {
            "types": [
              "doctype",
              "punctuation",
              "entity"
            ],
            "style": {
              "color": "hsl(220, 14%, 71%)"
            }
          },
          {
            "types": [
              "attr-name",
              "class-name",
              "maybe-class-name",
              "boolean",
              "constant",
              "number",
              "atrule"
            ],
            "style": {
              "color": "hsl(29, 54%, 61%)"
            }
          },
          {
            "types": [
              "keyword"
            ],
            "style": {
              "color": "hsl(286, 60%, 67%)"
            }
          },
          {
            "types": [
              "property",
              "tag",
              "symbol",
              "deleted",
              "important"
            ],
            "style": {
              "color": "hsl(355, 65%, 65%)"
            }
          },
          {
            "types": [
              "selector",
              "string",
              "char",
              "builtin",
              "inserted",
              "regex",
              "attr-value"
            ],
            "style": {
              "color": "hsl(95, 38%, 62%)"
            }
          },
          {
            "types": [
              "variable",
              "operator",
              "function"
            ],
            "style": {
              "color": "hsl(207, 82%, 66%)"
            }
          },
          {
            "types": [
              "url"
            ],
            "style": {
              "color": "hsl(187, 47%, 55%)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "textDecorationLine": "line-through"
            }
          },
          {
            "types": [
              "inserted"
            ],
            "style": {
              "textDecorationLine": "underline"
            }
          },
          {
            "types": [
              "italic"
            ],
            "style": {
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "important",
              "bold"
            ],
            "style": {
              "fontWeight": "bold"
            }
          },
          {
            "types": [
              "important"
            ],
            "style": {
              "color": "hsl(220, 14%, 71%)"
            }
          }
        ]
      },
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "navbar": {
      "title": "Refinery",
      "logo": {
        "src": "/logo.svg",
        "srcDark": "/logo-dark.svg"
      },
      "hideOnScroll": true,
      "items": [
        {
          "type": "doc",
          "label": "Learn",
          "docId": "learn/index",
          "position": "left"
        },
        {
          "type": "doc",
          "label": "Develop",
          "docId": "develop/java",
          "position": "left"
        },
        {
          "label": "GitHub",
          "position": "right",
          "href": "https://github.com/graphs4value/refinery"
        },
        {
          "label": "Try now",
          "position": "right",
          "href": "https://refinery.services/",
          "className": "navbar__link--try-now"
        },
        {
          "type": "docsVersionDropdown",
          "position": "right",
          "dropdownItemsBefore": [],
          "dropdownItemsAfter": []
        }
      ]
    },
    "footer": {
      "links": [
        {
          "title": "Learn",
          "items": [
            {
              "label": "Introduction",
              "to": "/learn"
            },
            {
              "label": "Tutorials",
              "to": "/learn/tutorials"
            },
            {
              "label": "Langauge reference",
              "to": "/learn/language"
            },
            {
              "label": "Run in Docker",
              "to": "/learn/docker"
            }
          ]
        },
        {
          "title": "Develop",
          "items": [
            {
              "label": "Programming guide",
              "to": "/develop/java"
            },
            {
              "label": "Contributing",
              "to": "/develop/contributing"
            },
            {
              "label": "Javadoc",
              "to": "/develop/javadoc"
            }
          ]
        },
        {
          "title": "More",
          "items": [
            {
              "label": "Try now",
              "href": "https://refinery.services/"
            },
            {
              "label": "GitHub",
              "href": "https://github.com/graphs4value/refinery"
            },
            {
              "label": "License",
              "to": "/license"
            },
            {
              "label": "Status",
              "href": "https://refinery.onlineornot.com/"
            }
          ]
        },
        {
          "title": "Supporters",
          "items": [
            {
              "label": "BME MIT FTSRG",
              "href": "https://ftsrg.mit.bme.hu/en/"
            },
            {
              "label": "McGill ECE",
              "href": "https://www.mcgill.ca/"
            },
            {
              "label": "2022 Amazon Research Awards",
              "href": "https://www.amazon.science/research-awards/recipients/daniel-varro-fall-2021"
            },
            {
              "label": "LiU Software and Systems",
              "href": "https://liu.se/en/organisation/liu/ida/sas"
            },
            {
              "label": "WASP",
              "href": "https://wasp-sweden.org/"
            }
          ]
        }
      ],
      "copyright": "\n          Copyright &copy; 2021-2024\n          <a href=\"https://github.com/graphs4value/refinery/blob/main/CONTRIBUTORS.md#the-refinery-authors\" target=\"_blank\">The Refinery Authors</a>.\n          Available under the\n          <a href=\"/license/\">Eclipse Public License - v 2.0</a>.\n        ",
      "style": "light"
    },
    "algolia": {
      "appId": "KYHOYEO80F",
      "apiKey": "152acfb8d1ad9e10f29f083a6b017a69",
      "indexName": "refinery",
      "externalUrlRegex": "/([^/]+/)?develop/javadoc/.+",
      "contextualSearch": true,
      "searchParameters": {},
      "searchPagePath": "search"
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "future": {
    "faster": {
      "lightningCssMinimizer": true,
      "mdxCrossCompilerCache": true,
      "rspackBundler": true,
      "swcHtmlMinimizer": true,
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "rspackPersistentCache": false,
      "ssgWorkerThreads": false,
      "gitEagerVcs": false
    },
    "v4": {
      "removeLegacyPostBuildHeadAttribute": false,
      "useCssCascadeLayers": false,
      "siteStorageNamespacing": false,
      "fasterByDefault": false,
      "mdx1CompatDisabledByDefault": false
    },
    "experimental_vcs": {},
    "experimental_router": "browser"
  },
  "headTags": [
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "href": "/favicon.svg",
        "type": "image/svg+xml"
      },
      "customElement": false
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "href": "/favicon.png",
        "type": "image/png",
        "sizes": "32x32"
      },
      "customElement": false
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "href": "/favicon-96x96.png",
        "type": "image/png",
        "sizes": "96x96"
      },
      "customElement": false
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "apple-touch-icon",
        "href": "/apple-touch-icon.png",
        "type": "image/png",
        "sizes": "180x180"
      },
      "customElement": false
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "manifest",
        "href": "/manifest.webmanifest"
      },
      "customElement": false
    },
    {
      "tagName": "meta",
      "attributes": {
        "name": "theme-color",
        "media": "(prefers-color-scheme:light)",
        "content": "#f5f5f5"
      },
      "customElement": false
    },
    {
      "tagName": "meta",
      "attributes": {
        "name": "theme-color",
        "media": "(prefers-color-scheme:dark)",
        "content": "#282c34"
      },
      "customElement": false
    }
  ],
  "i18n": {
    "defaultLocale": "en",
    "path": "i18n",
    "locales": [
      "en"
    ],
    "localeConfigs": {}
  },
  "storage": {
    "type": "localStorage",
    "namespace": false
  },
  "onBrokenLinks": "throw",
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "customFields": {},
  "presets": [],
  "scripts": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    },
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    }
  }
};
